// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"685500b3","488":"b8c28293"}[chunkId] + ".chunk.js";
};